export default (entry, form, vm) => {
    const url = entry.resource.cached_url
    setTimeout(() => {
        if (entry.forceSamePage) {
            window.location.assign(url)
        } else {
            window.open(url, '_blank')
        }
    }, +entry.delay)
}